export default {
  statusEnum: {
    PENDENTE: 1,
    EM_ANALISE: 2,
    AGUARDANDO_CLIENTE: 3,
    APOLICE_EM_EMISSAO: 4,
    DIRECIONAMENTO_COMERCIAL: 5,
    PROPOSTA_EXPIRADA: 6,
    AGUARDANDO_EFETIVACAO: 7,
    ENCERRADO: 8,
    SEGURO_REJEITADO: 9,
    RESERVA_NAO_ACEITA: 10,
    EFETIVANDO_PROPOSTA: 11,
    PROPOSTA_CONTESTADA: 12,
    PROCESSAMENTO: 13,
    SEM_FILTRO: 99
  },
  
  statusList: [
    {
      id: 1,
      descricao: 'Pendente',
      ordem: 2,
      statusCliente: 'Em Análise'
    },
    {
      id: 2,
      descricao: 'Em Análise',
      ordem: 4,
      statusCliente: 'Em Análise'
    },
    {
      id: 3,
      descricao: 'Aguardando Cliente',
      ordem: 6,
      statusCliente: 'Aguardando Assinatura'
    },
    {
      id: 4,
      descricao: 'Apólice em Emissão',
      ordem: 11,
      statusCliente: 'Apólice em Emissão'
    },
    {
      id: 5,
      descricao: 'Direcionamento Comercial',
      ordem: 3,
      statusCliente: 'Direcionamento Comercial'
    },
    {
      id: 6,
      descricao: 'Proposta Expirada',
      ordem: 8,
      statusCliente: 'Proposta Expirada'
    },
    {
      id: 7,
      descricao: 'Aguardando Efetivação',
      ordem: 9,
      statusCliente: 'Aguardando Efetivação'
    },
    {
      id: 8,
      descricao: 'Encerrado',
      ordem: 13,
      statusCliente: 'Apólice Emitida'
    },
    {
      id: 9,
      descricao: 'Seguro Rejeitado',
      ordem: 12,
      statusCliente: 'Seguro Rejeitado'
    },
    {
      id: 10,
      descricao: 'Reserva Não Aceita',
      ordem: 5,
      statusCliente: 'Risco Declinado'
    },
    {
      id: 11,
      descricao: 'Efetivando Proposta',
      ordem: 10,
      statusCliente: 'Aguardando Efetivação'
    },
    {
      id: 12,
      descricao: 'Proposta Contestada',
      ordem: 7,
      statusCliente: 'Proposta Contestada'
    },
    {
      id: 13,
      descricao: 'Processamento',
      ordem: 1,
      statusCliente: 'Em Análise'
    },
    {
      id: 99
    }
  ]
}


// WEBPACK FOOTER //
// ./src/helpers/estatus.js